export function wasPortfolioItemRemoved({ prevRemovedCartItemId, removedPortfolioCartItemId }) {
    return !!removedPortfolioCartItemId && prevRemovedCartItemId !== removedPortfolioCartItemId;
}
